export const initialAlerts = {
  alerts: [
    {
      id: "provisionalStatement",
      severity: "info",
      message: "Internal Use Only - Experimental",
    },
  ],
};
